import { render, staticRenderFns } from "./VendorAdd.vue?vue&type=template&id=03759c4e&scoped=true&"
import script from "./VendorAdd.vue?vue&type=script&lang=js&"
export * from "./VendorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03759c4e",
  null
  
)

export default component.exports